import { useContext, useEffect, useCallback } from "react";

import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

type Tx = { retry: () => void };

type Block = (tx: Tx) => void;

interface ExtendedNavigator extends Navigator {
  block(tx: Block): () => void;
}

export const useBlocker = (blocker: Function, when = true): void => {
  const navigatorContext = useContext(NavigationContext);
  const navigator = navigatorContext.navigator as unknown as ExtendedNavigator;
  useEffect(() => {
    if (!when) {
      return;
    }

    const unblock = navigator.block(tx => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock();
          tx.retry();
        },
      };

      blocker(autoUnblockingTx);
    });

    return unblock;
  }, [navigator, blocker, when]);
};

export const usePrompt = (message: string, when = true) => {
  const blocker = useCallback(
    (tx: Tx) => {
      if (window.confirm(message)) {
        tx.retry();
      }
    },
    [message],
  );

  useBlocker(blocker, when);
};
